import React from 'react';
import EligibilityHeroSection from './EligibilityHeroSection';
import EligibilityFormSection from './EligibilityFormSection';
import '../emiPage/EmiSection.css';
import usePageTitle from '../../hooks/UsePageTitle';

const EligibilityPage = () => {
  usePageTitle("Check Eligibility - Snapfunds");
  return (
    <div className="eligibility-page">
      <EligibilityHeroSection />
      <EligibilityFormSection />
    </div>
  );
};

export default EligibilityPage;

